require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventi-il-disegno-e-la-costruzione-della-n-2-chiasso-san-gottardo.json") })
        }
      }, "path---eventi-il-disegno-e-la-costruzione-della-n-2-chiasso-san-gottardo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventi-il-disegno-e-la-costruzione-della-n-2-chiasso-san-gottardo!./.cache/json/eventi-il-disegno-e-la-costruzione-della-n-2-chiasso-san-gottardo.json
// module id = 655
// module chunks = 231608221292675